class NovaProductBIS extends HTMLElement {
  constructor() {
    super();

    this.emailInput = this.querySelector('[data-bis-email-input]')
    this.submitButton = this.querySelector('[data-bis-submit]')
    this.errorMessage = this.querySelector('[data-bis-error-message]')
  }

  connectedCallback() {
    this.submitButton.addEventListener('click', this.submitBis.bind(this))
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.submitBis.bind(this))
  }

  isValidEmail = (email) => {
    const trimmedEmail = email.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
  }

  submitBis = async (event) => {
    event.preventDefault()

    this.classList.remove('error', 'success')

    try {
      const inputEmail = this.emailInput.value
      const variantId = this.querySelector('[name="id"]').value
      if (!this.isValidEmail(inputEmail)) {
        throw new Error('BIS: invalid email')
      }

      fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.publicKlaviyoId}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-07-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: inputEmail,
                    }
                  }
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          }),
        }
      ).then(result => {
        if (!result.ok) throw new Error('BIS: an error occurred')

        this.classList.add('success')
      })

    } catch (err) {
      this.classList.add('error')

      if(this.errorMessage !== null) {
        this.errorMessage.textContent = err.message
      }

      setTimeout(() => {
        this.emailInput.focus()
      }, 150)
    }
  }
}

if (typeof customElements.get('nova-product-bis') === 'undefined') {
  customElements.define('nova-product-bis', NovaProductBIS);
}
